module.exports = __webpack_public_path__ + "media/images/summary-doc-0ef446788c6011ff018e6bafe1158eaa.png";